
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';



const ValueCard = ({ value, index, type, brandColors, editMode, handleDelete, handleEdit }) => (
    <Card 
      elevation={1} 
      sx={{ 
        height: '100%',
        width: '100%',
        borderTop: `3px solid ${brandColors.accent}`,
        '&:hover': { 
          transform: 'translateY(-2px)', 
          boxShadow: 4,
          transition: 'all 0.3s ease'
        }
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={1}>
          <Typography variant="h6" sx={{ color: brandColors.dark, fontWeight: 600, mb: 1 }}>
            {value.title}
          </Typography>
          {editMode && (
            <Box sx={{marginLeft: 'auto' }}>
              <IconButton 
                size="small" 
                onClick={() => handleEdit(type, index)}
                sx={{ color: brandColors.primary}}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton 
                size="small" 
                onClick={() => handleDelete(type, index)}
                sx={{ color: 'error.main'}}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>
        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
          {value.description}
        </Typography>
      </CardContent>
    </Card>
  );
export default ValueCard ;